'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['bike', 'climb', 'gym', 'hike', 'run', 'sport', 'swim', 'walk'];


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/api/fitness-totals/consts/fitness-types.js
// module id = 1324
// module chunks = 0